import React from "react";

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: 800, margin: "auto", padding: 20, fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy</h1>

      <section>
        <h2>TL;DR</h2>
        <p>
          C0dify collects minimal personal data to operate the platform and improve user experience. We do not sell or share your data with third parties for marketing. Your privacy and security are priorities. Data is handled responsibly and transparently.
        </p>
      </section>

      <section>
        <h2>1. Information We Collect</h2>
        <p>
          We collect the following data:
        </p>
        <ul>
          <li>Account details (username, email)</li>
          <li>Contest participation and performance data</li>
          <li>Technical data (device type, IP address, usage logs)</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Your Data</h2>
        <p>
          Your data is used to:
        </p>
        <ul>
          <li>Provide and improve C0dify services</li>
          <li>Prevent fraud and maintain fair contests</li>
          <li>Communicate important updates and support</li>
          <li>Analyze usage to enhance platform features</li>
        </ul>
      </section>

      <section>
        <h2>3. Data Sharing</h2>
        <p>
          We do not sell or rent your personal data. We share data only with trusted service providers when necessary for platform operation, under strict confidentiality.
        </p>
      </section>

      <section>
        <h2>4. Data Security</h2>
        <p>
          We implement industry-standard measures to protect your data from unauthorized access, loss, or misuse.
        </p>
      </section>

      <section>
        <h2>5. Your Rights</h2>
        <p>
          You may access, correct, or delete your personal information by contacting support. You can also opt out of non-essential communications.
        </p>
      </section>

      <section>
        <h2>6. Cookies and Tracking</h2>
        <p>
          C0dify uses cookies and similar technologies to improve user experience and analyze platform usage. You can manage cookie preferences via your browser.
        </p>
      </section>

      <section>
        <h2>7. Children's Privacy</h2>
        <p>
          C0dify does not knowingly collect personal data from children under 13. If detected, such data will be deleted promptly.
        </p>
      </section>

      <section>
        <h2>8. Changes to This Policy</h2>
        <p>
          Privacy policy updates will be posted here. Continued use of the platform constitutes acceptance of changes.
        </p>
      </section>

      <section>
        <h2>9. Contact</h2>
        <p>
          For privacy inquiries, contact us at hello@c0dify.xyz
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
